import React, { useState, useEffect } from 'react'
import './main.css'
import couple from '../../images/couple.png'
import flowers from '../../images/flowers.png'
import breakfast from '../../images/breakfast.png'
import background from '../../images/fridge_background.png'
import fridge from '../../images/fridge.png'
import left from '../../images/left.png'
import right from '../../images/right.png'
import olya from '../../images/olya.png'
import lera from '../../images/lera.png'
import stas from '../../images/stas.png'
import tolik from '../../images/tolik.png'
import vitya from '../../images/vitya.png'

function Main() {

  let [ artistId, setArtistId ] = useState({
    id: 0
  })

  let [ artists, setArtists ] = useState({
    artist1: olya,
    artist2: lera,
    artist3: stas,
    artist4: tolik,
    artist5: vitya
  })

  const { actors } = require('../../data.json');

  function switchCharacter(change) {
    if (change === "next") {
      setArtistId(prevState => {
        let id = prevState.id
        id++
        id = (id > 4) ? 0 : id
        return { id: id }
      })
    } else if (change === "prev") {
      setArtistId(prevState => {
        let id = prevState.id
        id--
        id = (id < 0) ? 4 : id
        return { id: id }
      })
    }
  }

  useEffect(() => {
    if (artistId.id === 0) {
      setArtists({
        artist1: olya,
        artist2: lera,
        artist3: stas,
        artist4: tolik,
        artist5: vitya
      })
    }
    if (artistId.id === 1) {
      setArtists({
        artist1: stas,
        artist2: tolik,
        artist3: vitya,
        artist4: olya,
        artist5: lera
      })
    }
    if (artistId.id === 2) {
      setArtists({
        artist1: lera,
        artist2: stas,
        artist3: tolik,
        artist4: vitya,
        artist5: olya
      })
    }
    if (artistId.id === 3) {
      setArtists({
        artist1: vitya,
        artist2: olya,
        artist3: lera,
        artist4: stas,
        artist5: tolik
      })
    }
    if (artistId.id === 4) {
      setArtists({
        artist1: tolik,
        artist2: vitya,
        artist3: olya,
        artist4: lera,
        artist5: stas
      })
    }
  }, [artistId])

  return (
    <main className="main">
      <div className="main__container">
        <div className="main__video">
          <iframe
            className="main__video-frame"
            src="https://ok.ru/videoembed/2466930630196"
            title="video"
            frameborder="0"
          />
        </div>
        <section className="main__about" id="plot">
          <section className="main__images">
            <img className="main__image-couple" src={couple} alt=""/>
            <img className="main__image-flowers" src={flowers} alt=""/>
            <img className="main__image-breakfast" src={breakfast} alt=""/>
          </section>
          <article className="main__description">
            <h2 className="descrition__header title">Cюжет</h2>
            <p className="descrition__story text">Желая самостоятельно накопить деньги на предстоящую свадьбу, Стас и Оля решают потесниться и сдать в аренду знакомым две из трех комнат квартиры, которую не так давно им подарили родители. Герои будут учиться брать ответственность за свои решения и поступки и обретут новых настоящих друзей</p>
            <section className="descrition__info">
              <p className="info__genre small-text">Жанр: Комедия</p>
              <p className="info__actors small-text">Актеры: Лукерья Ильяшенко, Артём Цуканов, Дмитрий Ендальцев, Юлия Франц, Артём Ешкин, Баин Бовальдинов</p>
              <p className="info__runtime small-text">Продолжительность: 30 минут</p>
              <button className="info__button button">
                <a className="link" href="https://ok.ru/fiveplus/album/928897629748" target="_blank">фото со съемок</a>
              </button>
            </section>
          </article>
        </section>
        <section className="main__characters" id="heroes">
          <section className="character__images">
            <img className="character__image-big image-1" src={artists.artist1} alt=""/>
            <img className="character__image-small image-2" src={artists.artist2} alt=""/>
            <img className="character__image-small image-3" src={artists.artist3} alt=""/>
            <img className="character__image-small image-4" src={artists.artist4} alt=""/>
            <img className="character__image-small image-5" src={artists.artist5} alt=""/>
          </section>
          <section className="characters__images-background">
            <img className="characters__fridge" src={fridge} alt=""/>
            <img className="characters__background" src={background} alt=""/>
          </section>
          <section className="character">
            <h2 className="character__list title">Герои сериала</h2>
            <h3 className="character__name">{actors[artistId.id].character}</h3>
            <p className="character__actor small-text">{actors[artistId.id].actor}</p>
            <section className="character__buttons">
              <img className="character__button" src={left} alt="" onClick={() => switchCharacter("prev")}/>
              <img className="character__button" src={right} alt="" onClick={() => switchCharacter("next")}/>
            </section>
            <p className="charatcter__text text">{actors[artistId.id].description}</p>
            <button className="character__heroes-photos button">
              <a className="link" href="https://ok.ru/fiveplus/album/928897623860" target="_blank">фото героев</a>
            </button>
          </section>
        </section>
      </div>
    </main>
  )
}

export default Main

// <iframe className="main__video-frame" src="https://ok.ru/videoembed/2466930630196" width={window.innerWidth < 400 ? "300px" : "952px"} height={window.innerWidth < 400 ? "169px" : "536px"} frameborder="0" allow='autoplay'></iframe>
